export default __webpack_public_path__ + "../images/apple-touch-icon-144x144.png";